<script>
export default {
  name: "entries-pagination",
  props: {
    total: {
      default: 0,
      type: Number
    },
    paged: {
      default: 0,
      type: Number
    },
    range: {
      default: 2,
      type: Number
    },
    baseURL: {
      default: undefined,
      type: String
    }
  },
  computed: {
    expected: function() {
      return this.range * 2 + 1;
    },
    current: function() {
      return this.paged == 0 ? 1 : this.paged;
    }
  },
  methods: {
    getUrl: function() {
      return typeof this.baseURL === "undefined"
        ? document.location.href
        : this.baseURL;
    },
    urlBase: function() {
      return this.getUrl().split("?")[0];
    },
    urlVars: function() {
      let vars = this.getUrl().split("?")[1];
      if (typeof vars === "undefined") {
        return Object;
      }
      return vars
        .replace(/(^\?)/, "")
        .split("&")
        .map(
          function(n) {
            return (n = n.split("=")), (this[n[0]] = n[1]), this;
          }.bind({})
        )[0];
    },
    urlNew: function(modifier = {}) {
      let urlParams = this.urlVars();
      for (let key in modifier) {
        if (typeof modifier[key] === "undefined") {
          delete urlParams[key];
        } else {
          urlParams[key] = modifier[key];
        }
      }
      if (typeof urlParams.paged !== "undefined") {
        if (typeof urlParams.paged !== "number" || urlParams.paged < 2) {
          delete urlParams.paged;
        }
      }
      // urlParams = jQuery.param(urlParams);
      urlParams = new URLSearchParams(Object.entries(urlParams));
      return urlParams.length
        ? this.urlBase() + "?" + urlParams
        : this.urlBase();
    },
    calcPages: function() {
      let pagesArray = [];
      pagesArray.push(this.current);
      let count_prev_items = 0;
      for (let i = this.current - 1; count_prev_items < this.range; i--) {
        if (i >= 1) {
          pagesArray.push(i);
          count_prev_items++;
        }
        if (i <= 1) break;
      }
      let count_next_items = 0;
      for (let i = this.current + 1; count_next_items < this.range; i++) {
        if (i <= this.total) {
          pagesArray.push(i);
          count_next_items++;
        }
        if (i >= this.total) break;
      }
      let count_items_now = count_prev_items + count_next_items + 1;
      if (count_items_now < this.expected) {
        let missing = this.expected - count_items_now;
        if (count_next_items < this.range) {
          for (let i = Math.min(...pagesArray) - 1; missing > 0; i--) {
            if (i <= 0) break;
            if (i >= 1) {
              pagesArray.push(i);
              missing--;
            }
          }
        }
        if (count_prev_items < this.range && Math.max(...pagesArray) != 0) {
          for (var i = Math.max(...pagesArray) + 1; missing > 0; i++) {
            if (i >= this.total) break;
            if (i <= this.total) {
              pagesArray.push(i);
              missing--;
            }
          }
        }
      }
      pagesArray.sort(function(a, b) {
        return a - b;
      });
      return pagesArray;
    }
  }
};
</script>

<template>
  <nav
    id="applicationsFinder__pagination"
    class="pagination is-right"
    role="navigation"
    aria-label="Pagination"
  >
    <a
      v-if="current > 1"
      class="pagination-previous"
      :href="urlNew({ paged: current - 1 })"
      @click.prevent="$emit('paged', current - 1)"
      >Prev</a
    >
    <a v-else class="pagination-previous" disabled>Prev</a>
    <a
      v-if="current < total"
      class="pagination-next"
      :href="urlNew({ paged: current + 1 })"
      @click.prevent="$emit('paged', current + 1)"
      >Next</a
    >
    <a v-else class="pagination-next" disabled>Next</a>
    <ul class="pagination-list">
      <template v-for="page in calcPages()">
        <li :key="page" v-if="page == current">
          <a class="pagination-link is-current" :aria-label="'Page ' + page">{{
            page
          }}</a>
        </li>
        <li :key="page" v-else>
          <a
            class="pagination-link"
            :aria-label="'Goto page ' + page"
            :href="urlNew({ paged: page })"
            @click.prevent="$emit('paged', page)"
            >{{ page }}</a
          >
        </li>
      </template>
    </ul>
  </nav>
</template>

<style scoped>
/* ul {
  display: block;
  padding: 0;
  margin: 0;
}
li {
  display: inline-block;
  padding: 0.5rem;
} */
</style>
